export default function XSLT_Template() {
  return (
    <div>
      <h1>XSLT_Template</h1>
      <p>This is the XSLT_Template component.</p>
    </div>
  );
}